import { Button } from '@aqarmap/aqarmap-ui';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { useFullRoutes } from '~/hooks';

const PropertyValuationEmptyState = () => {
  const { t } = useTranslation('app');
  const navigate = useNavigate();
  const { VALUATION_URL } = useFullRoutes();

  return (
    <div className="flex flex-col gap-2x justify-center items-center h-full pb-20 px-2x">
      <div className="h-[204px] w-[343px] relative">
        <img
          src={`${process.env.PUBLIC_URL}/assets/images/no-results.png`}
          alt="placeholder"
        />
      </div>
      <div className="flex flex-col gap-1.5x">
        <p className="text-center text-title_4">
          {t('noValuationResultsFound')}
        </p>
        <p className="text-center text-gray__dark_2 text-body_1">
          {t('noValuationResultsFoundDescription')}
        </p>
      </div>
      <Button
        variant="primary"
        size="medium"
        onClick={() => navigate(VALUATION_URL.ADD)}
      >
        {t('addNewValuation')}
      </Button>
    </div>
  );
};

export default PropertyValuationEmptyState;
